import dayjs from 'dayjs';

export enum OrderType {
    DIGITAL = 'digital',
    PHYSICAL = 'physical',
}

export enum OrderSubType {
    ServiceOrderStoreMagento = 'sosmagento',
    MyNintendoStorePhysical = 'mnsphysical',
    ESHOP = 'eshop',
}

export enum OrderSource {
    SOM = 'SOM',
}

export interface OrderModel {
    type: OrderType;
    id: number | string;
    country: string;
    date: dayjs.Dayjs | undefined;
    items: OrderItem[];
    isGuestOrder?: boolean;
    contentType?: number;
    channel?: string;
    subType: OrderSubType;
    orderSource?: string;
    totalAmount?: number;
    refundAmount?: number;
    refundDate?: string;
}

export interface OrderItem {
    description: string;
    orderStatus?: string;
    shipDate?: dayjs.Dayjs;
    carrierName?: string;
    trackingNumber?: string;
    trackingUrl?: string;
}
